import { toastController } from "@ionic/core";
import { SWASTHCONFIG } from "src/config";

export const SWASTH_CONST =
{
    PATIENT_PROFILE: '',
    SELECTED_CIRCLE: '',
    HOSPITALURLTENANT: "",
    buttonDisable: false,
    pageType:"",
    appointmentSingleLink:"",
    
    async showToastAlert(msg) {
        let dispTime:number=0;
        if(msg=="Please wait....") {
          dispTime=500;
        } else {
          dispTime=3000;
        }
        let toast = toastController.create({
          message: msg,
          duration: dispTime,
          position: 'bottom'
        });
        (await toast).present();
    },

    showAlertBox(msg) {
        alert(msg);
    },

    apiErrorHandling(err) {
      console.log("errr", err);
      if(err.status==0) {
        console.log("case1");
        // alert("net::ERR_INTERNET_DISCONNECTED. Connection lost please check internet.");
        console.log("net::ERR_INTERNET_DISCONNECTED. Connection lost please check internet.")
      } else if(err.status==500) {
        alert("Unknown Error Occured. Internal Server Error 500.");
        // console.log("Unknown Error Occured. Internal Server Error 500.")
      }
    },
}